const cache = new Map();

const CACHE_TTL = {
	'/api/v1/admin/dashboard/stats': 5 * 60 * 1000,
	'/api/v1/admin/accounts': 2 * 60 * 1000,
	'/api/v1/admin/features': 10 * 60 * 1000,
};

function getCacheKey(endpoint, params) {
	return `${endpoint}?${new URLSearchParams(params || {}).toString()}`;
}

function getCached(key) {
	const cached = cache.get(key);
	if (!cached) return null;
	
	if (Date.now() > cached.expiresAt) {
		cache.delete(key);
		return null;
	}
	
	return cached.data;
}

function setCache(key, data, ttl) {
	cache.set(key, {
		data,
		expiresAt: Date.now() + ttl
	});
}

export function invalidateCache(pattern) {
	for (const key of cache.keys()) {
		if (key.includes(pattern)) {
			cache.delete(key);
		}
	}
}

export async function apiRequest(endpoint, options = {}, useCache = false) {
	const token = sessionStorage.getItem('adminToken');
	const cacheKey = getCacheKey(endpoint, options.params);
	
	if (useCache && options.method === 'GET') {
		const cached = getCached(cacheKey);
		if (cached) {
			console.log('[API Cache HIT]', cacheKey);
			return cached;
		}
		console.log('[API Cache MISS]', cacheKey);
	}
	
	const config = {
		...options,
		headers: {
			'Content-Type': 'application/json',
			...(token && { 'Authorization': `Bearer ${token}` }),
			...options.headers,
		},
	};
	
	const url = `${endpoint}${options.params ? '?' + new URLSearchParams(options.params) : ''}`;
	const response = await fetch(url, config, { signal: options.signal });
	
	if (!response.ok) {
		if (response.status === 401) {
			sessionStorage.removeItem('adminToken');
			window.location.reload();
		}
		const error = await response.json().catch(() => ({ message: 'Request failed' }));
		throw new Error(error.message || 'Request failed');
	}
	
	const data = await response.json();
	
	if (useCache && options.method === 'GET') {
		const ttl = CACHE_TTL[endpoint.split('?')[0]] || 60 * 1000;
		setCache(cacheKey, data, ttl);
	}
	
	return data;
}
